import { FC } from 'react';
import { BilledEntityItem } from 'src/use-cases/settings/useBilledEntities';
import { EntityItemWithSubEntities } from './EntityItemWithSubEntities';

interface EntityListProps {
  entities: BilledEntityItem[];
  depth?: number; // 0 for root level, 1 for first sub-level, etc.
  parentPath?: number[]; // Array of parent IDs representing the path to this level
  onToggle: (path: number[]) => void; // Single toggle handler with path array
}

export const EntityList: FC<EntityListProps> = ({ entities, depth = 0, parentPath = [], onToggle }) => {
  // Recursively calculate the selected count for an entity and all its descendants
  const calculateSelectedCount = (entity: BilledEntityItem): number => {
    // Count this entity if selected
    const selfCount = entity.selected ? 1 : 0;

    // Recursively count all selected descendants
    const descendantCount = entity.subEntities?.reduce((count, subEntity) => count + calculateSelectedCount(subEntity), 0) || 0;

    return selfCount + descendantCount;
  };

  return (
    <div className={`relative ${depth === 0 ? 'flex flex-col gap-8' : ''}`}>
      {entities.map((entity) => (
        <EntityItemWithSubEntities
          key={entity.id}
          entity={entity}
          depth={depth}
          parentPath={parentPath}
          onToggle={onToggle}
          calculateSelectedCount={calculateSelectedCount}
        />
      ))}
    </div>
  );
};
